import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnToggle(props) {
  let value = useDataValue({
    context: 'tab',
    path: 'selected.ledger.show_future_entries',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.show_future_entries',
    viewPath: props.viewPath,
  })
  return function onToggle() {
    change(!value)
  }
}
